if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      const variantInput =
        this.form.querySelector('[name="id"].product-variant-id') ||
        Array.from(this.form.querySelectorAll('[name="id"]')).find((input) => input.value);

      if (!variantInput || !variantInput.value) {
        this.handleErrorMessage('Please select a product option.');
        return;
      }

      const selectedBundleQuantity = this.form.querySelector('input[name="cb"]:checked');
      const quantityInput = this.form.querySelector('[name="quantity"]');

      const quantity =
        selectedBundleQuantity && selectedBundleQuantity.value
          ? selectedBundleQuantity.value
          : quantityInput && quantityInput.value
            ? quantityInput.value
            : 1;

      window.location.href = `/cart/add?id=${encodeURIComponent(variantInput.value)}&quantity=${encodeURIComponent(quantity)}`;
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}